import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { affiliationPosts } from '../data/blogAffiliationList';

const OutilsPage = () => {
  // Regrouper les articles par group puis par category
  const groups = affiliationPosts.reduce((acc, post) => {
    if (!acc[post.group]) acc[post.group] = {};
    if (!acc[post.group][post.category]) acc[post.group][post.category] = [];
    acc[post.group][post.category].push(post);
    return acc;
  }, {});

  return (
    <>
      <Helmet>
        <title>Outils & Logiciels - Avis et Comparatifs | Excellence Informatique</title>
        <meta name="description" content="Découvrez nos avis complets sur les meilleurs logiciels et outils du marché. Comparatifs, tests et recommandations par nos experts." />
        <link rel="canonical" href="https://mon-depannage-informatique.fr/outils" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Outils & Logiciels - Avis et Comparatifs | Excellence Informatique" />
        <meta property="og:description" content="Avis complets sur les meilleurs logiciels et outils du marché." />
        <meta property="og:url" content="https://mon-depannage-informatique.fr/outils" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div style={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        color: '#1f2937',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: 'clamp(1rem, 4vw, 2rem)'
        }}>
          {/* En-tête */}
          <div style={{
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)',
            paddingBottom: 'clamp(1.5rem, 4vw, 2rem)',
            borderBottom: '2px solid #e5e7eb'
          }}>
            <h1 style={{
              fontSize: 'clamp(2rem, 6vw, 2.5rem)',
              fontWeight: '800',
              lineHeight: '1.25',
              color: '#1f2937',
              margin: '0 0 1rem 0'
            }}>
              Outils & Logiciels
            </h1>
            <p style={{
              fontSize: 'clamp(1rem, 3vw, 1.25rem)',
              color: '#6b7280',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Nos avis complets et comparatifs pour choisir les meilleurs outils
            </p>
          </div>

          {/* Contenu : groupes et catégories */}
          {affiliationPosts.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '4rem 2rem',
              color: '#6b7280'
            }}>
              <p style={{ fontSize: '1.125rem' }}>Les articles arrivent bientôt...</p>
            </div>
          ) : (
            Object.entries(groups).map(([groupName, categories]) => (
              <div key={groupName} style={{ marginBottom: '3rem' }}>
                <h2 style={{
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  fontWeight: '700',
                  color: '#1f2937',
                  marginBottom: '1.5rem',
                  paddingBottom: '0.5rem',
                  borderBottom: '2px solid #3b82f6',
                  display: 'inline-block'
                }}>
                  {groupName}
                </h2>

                {Object.entries(categories).map(([categorySlug, posts]) => {
                  const catLabel = posts[0].categoryLabel;
                  return (
                    <div key={categorySlug} style={{ marginBottom: '2rem' }}>
                      <h3 style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#6b7280',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        marginBottom: '1rem'
                      }}>
                        {catLabel}
                      </h3>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                        gap: '1.5rem'
                      }}>
                        {posts.map((post) => (
                          <Link
                            key={post.id}
                            to={`/outils/${post.category}/${post.id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                          >
                            <div
                              style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #e5e7eb',
                                borderRadius: '1rem',
                                overflow: 'hidden',
                                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.1)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0,0,0,0.1)';
                              }}
                            >
                              {post.image && (
                                <div style={{ height: '180px', overflow: 'hidden' }}>
                                  <img
                                    src={post.image}
                                    alt={post.title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                  />
                                </div>
                              )}
                              <div style={{ padding: '1.25rem' }}>
                                <h4 style={{
                                  fontSize: '1.05rem',
                                  fontWeight: '700',
                                  color: '#1f2937',
                                  margin: '0 0 0.5rem 0',
                                  lineHeight: '1.4'
                                }}>
                                  {post.title}
                                </h4>
                                <p style={{
                                  fontSize: '0.875rem',
                                  color: '#6b7280',
                                  margin: '0 0 0.75rem 0',
                                  lineHeight: '1.5',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden'
                                }}>
                                  {post.description}
                                </p>
                                <span style={{
                                  fontSize: '0.75rem',
                                  color: '#9ca3af'
                                }}>
                                  {post.readingTime}
                                </span>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default OutilsPage;
